<template>
  <div class="contentSet">
    <el-row :gutter="12" type="flex">
      <el-col :span="16">
        <el-form class="contentSetForm" :model="contentSetForm" :rules="contentSetRules" ref="contentSetForm" >
          <!-- 营销目的 -->
          <el-form-item :label="'营销目的'" label-width="100px"  prop="name">
            <el-autocomplete
              class="inline-input"
              v-model="contentSetForm.name"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              @select="handleSelect"
              clearable
              :maxlength="500"
              size="small" @blur="contentSetFormData('name')"
            ></el-autocomplete>
            <!-- <el-input placeholder="输入文字" v-model.trim="contentSetForm.name" size="small" @blur="contentSetFormData('name')"></el-input> -->
          </el-form-item>
          <!-- 邮件语言 -->
          <el-form-item :label="'邮件语言'" label-width="100px" prop="language">
            <el-radio-group v-model="contentSetForm.language" size="small" @change="contentSetFormData('language')">
              <!-- <el-radio :label="2" >中文</el-radio> -->
              <el-radio :label="1" >英语</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 邮件主题 -->
          <el-form-item :label="'邮件主题'" label-width="100px" prop="title">
            <div class="emailTitle">
              <div class="emailTitleInput">
                <el-input placeholder="输入英文邮件主题" clearable v-model="contentSetForm.title" :maxlength="500" size="small" @blur="contentSetFormData('title')"></el-input>
              </div>
              <div class="emailTitleAI" @click="AIbtnShowFun('second')">
                想不出？小智帮你
              </div>
            </div>

          </el-form-item>
          <!-- 邮件称谓 -->
          <el-form-item :label="'邮件称谓'" label-width="100px" >
            <!-- 根据邮件语言的选择而联动显示。当邮件语言为英语时，则显示英文Dear称谓；当邮件语言为中文时，则显示中文称谓（亲爱的${UserName}） -->
            <el-checkbox v-model="contentSetForm.showUserName" size="small" @change="contentSetFormData('showUserName')">{{contentSetForm.language==1?'Dear ${UserName}':'亲爱的${UserName}'}}</el-checkbox>
            <div class="title-ps">注意：正文内容，在下方填充即可。系统会自动加上勾选的邮件签名 ，勾选称谓。如果去除称谓勾选，则邮件内容不显示称谓。</div>
          </el-form-item>
          <!-- 邮件正文 -->
          <el-form-item :label="'邮件正文'" label-width="100px" prop="content">
            <!-- <el-input placeholder="输入文字" v-model="contentSetForm.content" size="small"></el-input> -->
            <tinyeditor
              :resize="true"
              :minHeight="500"
              :maxHeight="null"
              :content="content"
              :maxSize="20000"
              @geEditor="geEditor"
              :AIbtnShow="AIbtnShow"
              @AIbtnShowFun="AIbtnShowFun"
            />
          </el-form-item>
          <!-- 邮件附件 -->
          <el-form-item :label="'邮件附件'" label-width="100px" >
              <uploadLine
                :uploadHandling="uploadHandling"
                :acceptType="acceptType"
                :partsVersion="0"
                :fileListArr="attachmentVos"
                :paramsupload="paramsupload"
                :size="5"
                :maxFiles="'最多支持5个附件上传'"
                :flieSize="'大小不超过5M'"
                @changeFileList="changeFileList1"
                :totalNum="5"
                :tempUrlShow="tempUrlShow"
              />
          </el-form-item>
          <!-- 邮件签名 -->
          <el-form-item :label="'邮件签名'" label-width="100px" >
            <el-popover
              placement="bottom"
              :trigger="triggerType"
              popper-class="popoverSign"
              v-model="SignShowPopover"
              ref="elpopover"
              >
              <div class="signListdivAll">
                <div class="signListdiv"  v-for="(item,index) in SingListArr" :key="index">
                  <div class="itemSign" @click="changeSign(item)">{{item.name}}</div>
                  <!-- <div class="itemSign">签名1</div>
                  <div class="itemSign">签名1</div> -->
                </div>
                <div>
                  <el-button type="text" @click="createdSignDialog">+新建签名</el-button>
                </div>
              </div>
              <el-button slot="reference" @click="SignShowPopover=!SignShowPopover" >增加签名</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label="" label-width="100px" v-if="contentSetForm.signatureId!=''">
            <div class="SingContent"  v-html="SingContent"> </div>
          </el-form-item>
          <!-- 退订链接 -->
          <el-form-item :label="'退订链接'" label-width="100px" >
            <div class="unsubscribe">为保证邮件触达率，已为您使用默认退订链接</div>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- <el-col :span="6">
        <div>
          小智AI写信
          <div>
            <el-popover
              placement="top-start"
              title="标题"
              width="200"
              trigger="manual"
              content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
              v-model="AIwritingShow">
                <div slot="reference" >小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信小智AI写信</div>
            </el-popover>
          </div>
        </div>
      </el-col> -->
    </el-row>
    <AIAbility ref="AIAbility" @AIdrawer="AIdrawer" :otherDrawerShow="true"/>
    <div>
      <el-dialog
        title="添加签名"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        custom-class="signDialog"
        >
        <div>
          <el-form :model="signForm" :rules="signcontentSetRules" class="contentSetForm signForm" ref="signForm">
            <el-form-item :label="'签名名称'" label-width="100px" prop="name" >
              <el-input placeholder="输入文字" v-model="signForm.name" size="small" maxlength="8" show-word-limit></el-input>
            </el-form-item>
            <el-form-item :label="'签名内容'" label-width="100px" prop="content" >
              <!-- <el-input placeholder="输入文字" v-model="signForm.content" size="small" maxlength="8"></el-input> -->
              <tinyeditor  
                :maxHeight="254"
                :content="signFormcontent"
                :maxSize="20000"
                @geEditor="signgeEditor"
              />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button v-no-more-click type="primary" @click="createdSign('0')" plain>保存并使用</el-button>
          <el-button v-no-more-click type="primary" @click="createdSign('1')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import tinyeditor from "@/components/tyniedor";
import uploadLine from "@/components/intellect-marketing/uploadLine"
import AIAbility from "@/components/intellect-marketing/mailDetail/AIAbility"
import {signatureList,signatureSave} from "@/utils/api/edmSubject"
export default {
  components: {
    tinyeditor,uploadLine,AIAbility
  },
  data(){
    
    var nameData = (rule, value, callback) => {
      if (value.trim()==''||value=='') {
        return callback(new Error('请输入营销目的'));
      } else {
        callback();
      }
    }

    var titleData = (rule, value, callback) => {
      if (value.trim()==''||value=='') {
        return callback(new Error('输入英文邮件主题'));
      } else {
        callback();
      }
    }

      var contentData = (rule, value, callback) => {
        if (this.contentSetForm.content.length <= 61) {
          return callback(new Error('请输入邮件正文'));
        } else {
          callback();
        }
      }
      var contentSing = (rule, value, callback) => {
        if (this.signForm.content.length <= 61) {
          return callback(new Error('请输入签名内容'));
        } else  {
          callback();
        }
      }
    return{
      edm_purpose: [],
      content:'',//邮件富文本框
      signFormcontent:'',//签名富文本框
      AIbtnShow:true,
      contentSetForm: {
        name:'',//任务名称
        language:1,//语言 1=英文 2=中文
        title:'',//邮件标题
        showUserName:true,//邮件称谓 0=不显示 1=亲爱的xx
        content:'',//邮件正文
        signatureId:'',//邮件签名表id
        hashcodeList:[],//附件hashcode
      },
      contentSetRules: {
        name: [
          { required: true, validator:nameData,  message: '请输入营销目的', trigger: 'blur' }
        ],
        language:[
          { required: true, message: '请选择邮件语言', trigger: 'change' }
        ],
        title: [
          { required: true, validator:titleData, message: '', trigger: 'blur' }
        ],
        content:[
          { required: true, validator: contentData, trigger: 'blur' }
        ],
      },
      dialogVisible:false,
      signForm:{
        name:'',//签名名称
        content:'',//签名内容
        isDef:'',//是否默认 0:是 1:否
      },
      signcontentSetRules:{
        name: [
          { required: true, message: '请输入签名名称', trigger: 'blur' }
        ],
        content:[
          { required: true,  validator: contentSing,  trigger: 'blur' }
        ],
      },
      triggerType:'manual',
      SignShowPopover:false,
      SingListArr:[],//签名列表
      SingContent:'',//签名内容
      acceptType:".ppt,.pptx,.pdf,.png,.jpg,.jpeg",
      drawingVoList: [],
      paramsupload: {
        source: 91,
        sourceType: 91,
        isCreateThumbnail: false,
        project: 'haizol-seamark-web-online',
        modelType: 5,
        isCreateThumbnail: false,
        picSizeType: 1,
      },
      attachmentVos:[],
      uploadHandling:false,
      AIwritingShow:true,
      tempUrlShow:false,//下载附件是用临时还是正式,false:临时，true:正式
    }
  },
  mounted(){
    this.getSingList()
  },
  methods:{

    // 编辑时的传值
    contentSetData(formData){
      this.contentSetForm.name=formData.name
      // let optionsArr={
      //     value: formData.name,
      //     label: formData.name
      //   }
      // this.options.push(optionsArr)
      this.contentSetForm.language=formData.language
      this.contentSetForm.title=formData.title
      this.contentSetForm.showUserName=formData.showUserName==1?true:false
      this.contentSetForm.content=formData.content
      this.content=formData.content
      this.attachmentVos=[]
      let hashcodeList=[]
      if(formData.attachmentVos!=[]&&formData.attachmentVos!=null){
        this.attachmentVos=formData.attachmentVos
        formData.attachmentVos.map(item=>{
          hashcodeList.push(item.hashCode)
        })
      }
      if(this.attachmentVos.length>=5){
        this.uploadHandling=true
        this.contentSetForm.hashcodeList=this.attachmentVos
        this.tempUrlShow=true
      }else{
        this.uploadHandling=false
        this.contentSetForm.hashcodeList=hashcodeList
        this.tempUrlShow=false
      }
      // this.contentSetForm.signatureId=formData.signatureId
      this.changeSign(formData.signatureVo)
      this.contentSetFormData('tempUrlShow')
    },
    // 附件上传
    changeFileList1(arr, flag) {
      // const newArr = [];
      // arr.forEach((val, key) => {
      //   newArr.push(val.hashCode);
      // });  hashcode
      this.attachmentVos = arr;
      let hashcodeList=[]
      this.attachmentVos.map(item=>{
          hashcodeList.push(item.hashCode)
        })
      if(this.attachmentVos.length>=5){
        this.uploadHandling=true
        this.contentSetForm.hashcodeList=hashcodeList
        this.tempUrlShow=false
      }else{
        this.uploadHandling=false
         this.contentSetForm.hashcodeList=hashcodeList
      }
       this.contentSetFormData('hashcodeList')
       this.contentSetFormData('attachmentVos')
       this.contentSetFormData('tempUrlShow')
    },
    // 新建签名弹框
    createdSignDialog(){
      this.dialogVisible=true
    },
    // 选中签名
    changeSign(item){
      this.SignShowPopover=false
      // console.log(item)
      if(item!=null&&item.id!=-1){
        this.contentSetForm.signatureId=item.id
        this.SingContent=item.content
      }else{
        this.contentSetForm.signatureId=''
        this.SingContent=''
      }
      this.contentSetFormData('signatureId')
      if(this.contentSetForm.signatureId!=-1){
        this.contentSetFormData('SingContent')
      }
    },
    // 新建弹框
    handleClose() {
      this.dialogVisible=false
      this.SignShowPopover=false
      this.signForm.name=''
      this.signForm.content=''
    },
    // 保存新建签名
    async createdSign(type){
      if(type==0){
        this.contentSetForm.signatureId=''
      }
      new Promise((resolve, reject) => {
        this.$refs["signForm"].validate(valid => {
          resolve(valid)
        }).catch((err) => {
          reject(err);
        })
      }).then((resolve)=>{
        if(resolve){
          this.signForm.isDef=type
          const res= signatureSave(this.signForm)
          this.handleClose()
          setTimeout(()=>{
            this.getSingList()
          },500)
        }
      })
    },
    //签名富文本框
    signgeEditor(val){
      // console.log(val)
     this.signForm.content = val === "<p><br></p>" ? "" : val;
     this.$refs["signForm"].validateField('content');
    },
    // 获取签名列表
    async getSingList(){
      const res=await signatureList()
      this.SingListArr=res.rspListData.list
      var temp = {};
      temp.name = '不显示签名';
      temp.id = "-1";
      temp.content = "";
      this.SingListArr.push(temp);
      this.SingListArr.map((item)=>{
        if(this.contentSetForm.signatureId==''&&item.isDef==0){
          // console.log(this.contentSetForm.signatureId+'========================')
          this.contentSetForm.signatureId=item.id
          this.SingContent=item.content
        }
      })
      this.contentSetFormData('signatureId')
      this.contentSetFormData('SingContent')
    },
    // 邮件富文本框
    geEditor(val) {
      // console.log(val)
      this.contentSetForm.content = val === "<p><br></p>" ? "" : val;
      console.log(this.contentSetForm.content.length)
      // 单独校验一次
      this.$refs["contentSetForm"].validateField('content');
      this.contentSetFormData('content')
    },

    // 入参处理传入父组件
    //表单验证
    contentForm () {
      return new Promise((resolve, reject) => {
        this.$refs["contentSetForm"].validate(valid => {
          resolve(valid)
        }).catch((err) => {
          reject(err);
        });
      })
    },
    // 传参处理
    contentSetFormData(property){
      // console.log(this.contentSetForm[property])
      if(property=='showUserName'){
        this.$emit("contentSetFormData", property,this.contentSetForm[property]?1:0);
      }else if(property=='SingContent'){
        this.$emit("contentSetFormData", property,this.SingContent);
      }else if(property=='attachmentVos'){
        this.$emit("contentSetFormData", property,this.attachmentVos);
      }else if(property=='tempUrlShow'){
        this.$emit("contentSetFormData", property,this.tempUrlShow);
      }else{
        this.$emit("contentSetFormData", property,this.contentSetForm[property]);
      }
      
    },
    // AI窗口处理
    AIbtnShowFun(type){
      // console.log(type)
      if(type=='second'){
        this.$refs.AIAbility.activeName='second'
      }else{
        this.$refs.AIAbility.activeName='first'
      }
      this.$refs.AIAbility.drawer=true
      this.AIdrawer(true)
    },
    // AI窗口展示底部按钮要处理
    AIdrawer(val){
      this.$emit('AIdrawer',val)
    },
    querySearch(queryString, cb) {
      var restaurants = this.edm_purpose;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      console.log(this.contentSetForm.name)
      this.$refs["contentSetForm"].validateField('name');
      this.contentSetFormData('name')
    },
    handleIconClick(ev) {
      console.log(ev);
    },
        // // 根据类型批量获取字典数据
    async getInitDictByType(codeMap){
      this.edm_purpose=[]
      let temp=  {
            value: '',
            label: ''
          }
      codeMap.edm_purpose.map(item=>{
        let temp=  {
            value: item.name,
            label: item.name
          }
        this.edm_purpose.push(temp)
      })
      // console.log(this.edm_purpose)
    },
  },

}
</script>
<style lang="scss" scoped>
  .signListdivAll{
    height: 150px;
    overflow: auto;
    scrollbar-width: thin;
  }
    /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
.contentSet{
  margin-top: 16px;
 ::v-deep .contentSetForm{
  .el-input{
    width: 480px;
  }
    .el-form-item__label{
      color: #4f5d78ff;
      font-size: 12px;
      font-face: SourceHanSansCN;
      font-weight: 400;
    }
    .el-radio__label{
      font-size: 12px;
    }
    .el-checkbox__label{
      font-size: 12px;
    }
    .el-autocomplete{
      width: 100%;
    }
    .el-input--small .el-input__inner{
      width: 480px;
      font-size: 12px;
    }
    .sys-note-index{
      width: 640px;
      // .tox-tinymce{
      //   height: 337px !important;
      // }
      // .tox .tox-edit-area{
      //   height: 238px;
      // }
    }
  }
}
::v-deep .signForm{
  .el-input--small .el-input__inner{
    width: 100% !important;
    font-size: 12px;
  }
  .el-input{
    width: 100% !important;
  }
  .sys-note-index{
    width: 100% !important;
    // height: 254px !important;
  }
  // .tox-tinymce{
  //   height: 254px !important;
  // }
}
.signListdiv{
  line-height: 36px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #16181A;
  border-bottom: 1px solid #EDF0F4;
  margin-bottom: 2px;
  .itemSign{
    cursor: pointer;
  }
}
.unsubscribe{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #16181A;
  line-height: 30px;
}
::v-deep .SingContent {
  line-height: 18px;
  border: 1px solid #eeeeee;
  padding: 10px;
  // margin-top: 4px;
  width: 622px;
  overflow-x: auto;
  div {
    margin-bottom: 5px;
  }
  div,
  span,
  object,
  li,
  ul,
  img iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  pre,
  a,
  em,
  img,
  strong,
  sub,
  sup,
  b,
  i,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  menu,
  nav,
  output,
  ruby,
  section,
  abstractDesc,
  time,
  mark,
  audio,
  video,
  input,
  textarea,
  select,
  button,
  meter,
  progress {
    margin: revert;
  }
  a {
    color: rgb(0, 0, 238) !important;
  }
  img {
    // width: 100%;
  }
}
.title-ps{
  font-size: 12px;
  color: #ffac2f;
  line-height: 18px;
}
.emailTitle{
  display: flex;
  width:640px ;
  ::v-deep .emailTitleInput{
    .el-input--small .el-input__inner{
      width: 480px !important;
    }
  }
  .emailTitleAI{
    color: #3025BD !important;
    cursor: pointer;
    margin-left: 10px;
    font-size: 12px;
  }
}
::v-deep .common-upload{
  margin-bottom: 0px;
}
</style>
<style>
.popoverSign{
  /* min-width: 80px; */
  padding-bottom: 2px;


}

.signDialog{
  width: 528px !important;
}
</style>